module.exports = __webpack_public_path__ + "img/playstore_button.d6cf04df.png";